import type { ReactNode } from 'react';
import type { NavItem } from './MobileShell';
import { MobileShell } from './MobileShell';
import { DesktopShell } from './DesktopShell';
import { useMediaQuery } from './useMediaQuery';
import { useNavStyle } from './useNavStyle';

interface AppShellProps {
  navItems: NavItem[];
  children: ReactNode;
  title?: string;
  actions?: ReactNode;
  breadcrumb?: ReactNode;
  banner?: ReactNode;
  churchName?: string;
  user?: { name: string; role: string };
  onNavigate?: (href: string) => void;
}

export const AppShell = ({ navItems, children, title, actions, breadcrumb, banner, churchName, user, onNavigate }: AppShellProps) => {
  // Sidebar from tablet width up; a bottom tab bar below that (see the note in the polish report).
  const isDesktop = useMediaQuery('(min-width: 768px)');
  const [navStyle] = useNavStyle();

  if (isDesktop) {
    return (
      <DesktopShell
        navItems={navItems}
        title={title}
        actions={actions}
        breadcrumb={breadcrumb}
        banner={banner}
        churchName={churchName}
        user={user}
        onNavigate={onNavigate}
      >
        {children}
      </DesktopShell>
    );
  }

  return (
    <MobileShell
      navItems={navItems}
      title={title}
      actions={actions}
      breadcrumb={breadcrumb}
      banner={banner}
      churchName={churchName}
      user={user}
      navStyle={navStyle}
      onNavigate={onNavigate}
    >
      {children}
    </MobileShell>
  );
};
